"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlatLotContractNature = void 0;
var FlatLotContractNature;
(function (FlatLotContractNature) {
    FlatLotContractNature["PRIVATE"] = "vamstar exclusive";
    FlatLotContractNature["REFURBISHED"] = "refurbished";
})(FlatLotContractNature = exports.FlatLotContractNature || (exports.FlatLotContractNature = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmxhdC1sb3QtY29udHJhY3QtbmF0dXJlLmVudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbG90L3R5cGVzL2ZsYXQtbG90LWNvbnRyYWN0LW5hdHVyZS5lbnVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUVILElBQVkscUJBR1g7QUFIRCxXQUFZLHFCQUFxQjtJQUMvQixzREFBNkIsQ0FBQTtJQUM3QixvREFBMkIsQ0FBQTtBQUM3QixDQUFDLEVBSFcscUJBQXFCLEdBQXJCLDZCQUFxQixLQUFyQiw2QkFBcUIsUUFHaEMifQ==